/**
 * @author huancheng.zhan<huancheng.zhan@ukelink.com>
 * @description
 * @since 2018/3/12
 */

import Axios from 'axios';
import CookieHelper from '@/utils/cookieHelper'

/**
 * @type {AxiosInstance}
 */
const service = Axios.create({
    timeout: 60000
});


service.interceptors.request.use(config => {

	config.headers['Accept-Language'] = sessionStorage.getItem('langType');

    if (config["defaultParam"]) {
        let default_param = {
            streamNo: `webH5${+new Date()}${Math.floor(Math.random()*10000)}`,
            partnerCode: "UKAPP",
        };
        config.data = Object.assign({}, config.data, default_param);
    }

    return config;
});

service.interceptors.response.use(response => {

    // 成功执行
    let code = response.data.resultCode || response.data["subCode"] ;
    let result = response.data;

    //response.data._hash  属于配置文件
    //response.data.code  属于支付接口

    if (code === "00000000" || code === "0000" || response.data._hash || response.data.code ) {
        return result;
    } else if(code === '00000008' || code === '00000007' || code === '00000006') {
        /*
         * 00000008 => AccessToken does not belong to the loginCustomer
         * 00000007 => The access token expired
         * 00000006 => AccessToken is null
         * */
        window.dsBridge.call('nativeLogin');
    } else {
        return Promise.reject(result);
    }

}, error => {

    // 失败执行
    if (error.response) {
        return Promise.reject(error.response);
    }

});

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js